<template>
    <div class="thankyou">
        <div class="thankyou__text">
            <div class="thankyou__title">
                {{ $t('thankYou:title') }}
            </div>
            <div class="thankyou__info">
                {{ $t('thankYou:info') }}
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'ThankYou'
}
</script>
